var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.785,
    height: 49.5,
    viewBox: "0 0 53.785 49.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-682.215 -311.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M6.124 32.667A6.132 6.132 0 0 1 0 26.541V6.124A6.131 6.131 0 0 1 6.124 0h28.585a6.131 6.131 0 0 1 6.124 6.124v20.417a6.132 6.132 0 0 1-6.124 6.126zm-2.041-6.126a2.044 2.044 0 0 0 2.041 2.043h28.585a2.044 2.044 0 0 0 2.041-2.043V16.334H4.083zm32.667-14.29V6.124a2.043 2.043 0 0 0-2.041-2.041H6.124a2.043 2.043 0 0 0-2.041 2.041v6.126zm-24.5-4.085a2.041 2.041 0 1 1 2.041 2.043 2.042 2.042 0 0 1-2.04-2.043zm-6.126 0a2.042 2.042 0 1 1 2.041 2.043 2.043 2.043 0 0 1-2.041-2.043z",
    transform: "translate(682.215 311.5) translate(4.084 8.167)"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "rgba(45,255,214,0.58)",
    transform: "translate(711 336)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserIcon);
export default __webpack_public_path__ + "static/media/browserIcon.23a3fbbbd8e768e6f95df9af8f38c78f.svg";
export { ForwardRef as ReactComponent };